var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_5_55)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint1_radial_5_55)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4931 62.4927C35.9886 62.4927 33.8953 61.8322 30.2566 59.1904C27.955 62.1625 20.6668 64.4851 20.3489 60.5113C20.3489 57.5284 19.6913 55.0077 18.946 52.2558C18.0583 48.8654 17.05 45.0899 17.05 39.6192C17.05 26.5533 27.7249 16.7236 40.3726 16.7236C53.0312 16.7236 62.9499 27.0376 62.9499 39.7403C62.9924 52.2464 52.9451 62.426 40.4931 62.4927ZM40.6794 28.0173C34.52 27.6981 29.7196 31.98 28.6565 38.6946C27.7797 44.2534 29.336 51.0229 30.6621 51.3752C31.2978 51.5293 32.8979 50.2304 33.8953 49.2287C35.5444 50.373 37.4649 51.0602 39.4629 51.2211C45.8451 51.5294 51.2985 46.6495 51.727 40.2467C51.9764 33.8302 47.0625 28.3955 40.6794 28.0283V28.0173Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_55",
    x1: 9.42776,
    y1: 60.8429,
    x2: 80,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#5533EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9933DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5_55",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.90326 -35.1348) rotate(51.356) scale(97.0814 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.65fffcb64cbf3e7c11efd22762fd1792.svg";
export { ForwardRef as ReactComponent };